export default __webpack_public_path__ + "static/media/glyde-solar-bg.8f21f69c.jpeg";